export default __webpack_public_path__ + "static/media/finance_m.58a0e56f.png";